import { render } from "./BlockState.vue?vue&type=template&id=327589eb"
import script from "./BlockState.vue?vue&type=script&lang=js"
export * from "./BlockState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__